enum type {
  SET_LIST_DOCUMENTS_TYPES = 'SET_LIST_DOCUMENTS_TYPES',
  SET_LOADING_DOCUMENT_TYPES = 'SET_LOADING_DOCUMENT_TYPES',
  SET_SELECTED_DOCUMENT_TYPE = 'SET_SELECTED_DOCUMENT_TYPE'
}

export default type;